// HTTP client for external PULL integrations used by the automation builder (/admin/integrations).
// Today: Arbox. Migrated to the OpenAPI-generated client (AdminIntegrationController).
//
// connectArbox validates the company's key against the LIVE Arbox API, discovers that company's
// field set (every Arbox account has a different schema), and stores the key encrypted server-side.
// The response carries { connected, integrationId, last4, fields } — never the key itself.
//
// Each function keeps its old return shape (callers read res.data) — the adapter returns `{data}` and
// re-throws an axios-shaped `{response:{data,status}}` on error. Auth/timezone come from configureApi.

import {
    adminIntegrationControllerConnectArbox,
    adminIntegrationControllerArboxFields,
} from '../api/generated';

// Preserve the legacy axios rejection shape so call sites reading `e.response.data.errorMessage` keep working.
const throwLikeAxios = (error, response) => {
    throw {response: {data: error, status: response?.status}};
};

export const connectArbox = async (apiKey, companyId) => {
    const {data, error, response} = await adminIntegrationControllerConnectArbox({
        body: {apiKey},
        query: companyId ? {companyId} : {},
    });
    if (error) throwLikeAxios(error, response);
    return {data};
};

// Re-fetch the discovered fields for an already-connected company (reopening the builder).
export const getArboxFields = async (companyId) => {
    const {data, error, response} = await adminIntegrationControllerArboxFields({
        query: companyId ? {companyId} : {},
    });
    if (error) throwLikeAxios(error, response);
    return {data};
};
